export default {
  errorsRootKey: 'sms/linkmobility',
  resource: 'sms/linkmobility',
  actions: ['index', 'create', 'show', 'update', 'destroy'],

  configByAccount(customerId, params = {}, options = {}) {
    return Vue.http.get(
      `sms/linkmobility/getSettingbyCustomer/${customerId}`,
      {params, ...options}
    ).then(response => response.data)
  },

  testSMSLinkMobility(data = {}, options = {}) {
    return Vue.http.post(
      'sms/linkmobility/test',
      data
    ).then(response => response.data)
  }
}
